import axios from "axios";

const DEV_URL = `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/api/v1`;

const PROD_URL = `${process.env.REACT_APP_API_URL}/api/v1`;

const BASE_URL =
  process.env.REACT_APP_ENV === "dev"
    ? DEV_URL
    : PROD_URL;

export default axios.create({ baseURL: BASE_URL });
export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  // headers: { "Content-Type": "application/json" }, // à ajouter dans les requêtes qui envoient du JSON, pas pour les form-data
});
